module.exports = __webpack_public_path__ + "static/img/003-6.d3277c64.png";